import * as yup from 'yup';
import { RequiredStringSchema } from 'yup/lib/string';
import { GetSchema } from 'validations/types';

// TODO: we should switch to getEmailValidationSchema option.
//  Our dummy components should not know how do we do translations
//  They should just represent parts of the interface
const emailValidationSchema = yup.string().required('required').email('email-is-valid');

export default emailValidationSchema;

export const getEmailValidationSchema = ({
  translateFunc,
  baseKey = 'validation',
}: GetSchema): RequiredStringSchema<string | undefined> => {
  return yup
    .string()
    .required(translateFunc({ id: `${baseKey}:required` }))
    .email(translateFunc({ id: `${baseKey}:email-is-valid` }));
};
